/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentImpersonationExchangeResponseImpersonation model module.
 * @module model/AgentImpersonationExchangeResponseImpersonation
 * @version 1.0.0
 */
class AgentImpersonationExchangeResponseImpersonation {
    /**
     * Constructs a new <code>AgentImpersonationExchangeResponseImpersonation</code>.
     * @alias module:model/AgentImpersonationExchangeResponseImpersonation
     */
    constructor() { 
        
        AgentImpersonationExchangeResponseImpersonation.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentImpersonationExchangeResponseImpersonation</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentImpersonationExchangeResponseImpersonation} obj Optional instance to populate.
     * @return {module:model/AgentImpersonationExchangeResponseImpersonation} The populated <code>AgentImpersonationExchangeResponseImpersonation</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentImpersonationExchangeResponseImpersonation();

            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('admin_user_id')) {
                obj['admin_user_id'] = ApiClient.convertToType(data['admin_user_id'], 'Number');
            }
            if (data.hasOwnProperty('admin_user_name')) {
                obj['admin_user_name'] = ApiClient.convertToType(data['admin_user_name'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentImpersonationExchangeResponseImpersonation</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentImpersonationExchangeResponseImpersonation</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['admin_user_name'] && !(typeof data['admin_user_name'] === 'string' || data['admin_user_name'] instanceof String)) {
            throw new Error("Expected the field `admin_user_name` to be a primitive type in the JSON string but got " + data['admin_user_name']);
        }

        return true;
    }


}



/**
 * @member {Number} agent_id
 */
AgentImpersonationExchangeResponseImpersonation.prototype['agent_id'] = undefined;

/**
 * @member {Number} admin_user_id
 */
AgentImpersonationExchangeResponseImpersonation.prototype['admin_user_id'] = undefined;

/**
 * @member {String} admin_user_name
 */
AgentImpersonationExchangeResponseImpersonation.prototype['admin_user_name'] = undefined;






export default AgentImpersonationExchangeResponseImpersonation;

